/* eslint-disable header/header */
export const name = "@azure/msal-common";
export const version = "5.2.0";
